import router from '../router'
import store from '../store'
export function logout() {
  const loginFormInfo = sessionStorage.getItem('loginFormInfo') && JSON.parse(sessionStorage.getItem('loginFormInfo'))
  if (!loginFormInfo) router.replace('/')
  const { pathName } = loginFormInfo
  router.replace({
    name: pathName
  })
  store.dispatch('user/logout')
}


// WEBPACK FOOTER //
// ./src/utils/logout.js